import { useMutation } from 'react-query';
import { queryClient } from '../../../../config/queryClient';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { LongevityDTO, Params as LongevityQueryParams } from './useLongevityAnalysisQuery';

interface BodyParams {
  AllocateExcessCashflow: boolean;
  AllocatedCashflow: number;
  GoalId: string;
  IsInvalidated: boolean;
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
}

export interface Params {
  clientId: number;
  fpId: string | null;
  body: BodyParams;
}

export const saveLongevityAnalysisWhatIfs = ({ clientId, fpId, body }: Params): Promise<LongevityDTO> => {
  return authFetch(
    urlWithParams(`/Consumer/LongevityAnalysis/GetLongevityAnalysisDetailsWithWhatIfs`, {
      clientId,
      fpId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions(body, true),
    },
  );
};

export const useLongevityAnalysisWhatIfsMutation = ({ clientId, fpId }: Omit<LongevityQueryParams, 'enabled'>) => {
  return useMutation(saveLongevityAnalysisWhatIfs, {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.longevity(clientId, fpId));
    },
  });
};
